import { render, staticRenderFns } from "./EnvsBulk.vue?vue&type=template&id=99682ace&"
import script from "./EnvsBulk.vue?vue&type=script&lang=js&"
export * from "./EnvsBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports